import { ApexOptions } from 'apexcharts';

import { TFunction } from 'i18next';
import { UniquePestsChartData } from 'api/analitics/EncCharts/types';

export const uniqueTracesPerDayChartOptions = (data: UniquePestsChartData, t: TFunction) => {
  const chartOptions: ApexOptions = {
    series: data?.series || [],
    chart: {
      height: 350,
      type: 'area',
      zoom: {
        enabled: true,
      },
      toolbar: {
        show: true,
      },
    },
    markers: {
      size: 3,
      shape: 'circle',
    },
    stroke: {
      width: [3, 3],
      curve: 'smooth',
    },
    xaxis: {
      title: {
        text: t('ChartsAnalitics.encounters_charts.detacted_pests_signs_over_time.x_axis_title'),
        style: {
          fontSize: '12px',
        },
      },
      categories: data?.labels || [],
      type: 'category',
      tickPlacement: 'on',
    },
    yaxis: {
      title: {
        text: t('ChartsAnalitics.encounters_charts.detacted_pests_signs_over_time.y_axis_title'),
        style: {
          fontSize: '12px',
        },
      },
      min: 0,
      stepSize: 1,
      forceNiceScale: false,
      decimalsInFloat: 0,
      labels: {
        formatter: value => Math.floor(value).toString(),
      },
    },
    colors: ['#6A37D4', '#EED32E', '#94C748'],
  };

  return chartOptions;
};
